module.exports = __webpack_public_path__ + "img/bn17.93a85b8c.png";